<template>
    <div class="m-portlet">
        <div class="card-header">
            <h4>历史课程概况 </h4>
            <div style="position: absolute;right: 20px; z-index: 9999;top: 18px;">
                <div v-for="item in studentPeriodStyles"
                     style="float:left;margin:0 5px">
                    <div :style="{'background': item.color}"
                         style="float:left;width: 15px;height: 15px;border-radius: 50%"></div>
                    <div style="float:left;font-size: 12px;margin:0 5px">{{item.name}}</div>
                </div>
            </div>
        </div>
        <vue-scroll :ops="$ops">
            <div class="card-body" style="min-height: 200px;max-height:480px;">
                <div v-for="(courses,index) in $parentInfo.studentPeriod.historyPeriods" :key="index">
                    <div v-for="(course,index3) in courses" :key="index3">

                        <h6 class="m-b-10">
                            <el-row :gutter="20">
                                <el-col :span="6"> ({{course.semester_name}})-{{course.class_name}}</el-col>
                                <el-col :span="6">任课老师：{{course.teacher_name}}</el-col>

                                <el-col :span="6">时间段：{{course.time}}</el-col>
                            </el-row>
                        </h6>

                        <div style="position: relative;height: 30px;">
                            <div v-for="(class_plan_items,index1) in course.class_plan_item_arr" :key="index1">
                                <div v-for="(plan,index2) in class_plan_items"
                                     :key="index2"
                                     style="position:absolute;top:0;z-index: 10"
                                     :style="{'left':index1*50+index2*10+ 'px'}">
                                    <div slot="reference"
                                         style="width: 20px;height:20px;border-radius: 50%;    box-shadow: 0 0 1px 1px rgba(22,25,49,0.5);;"
                                         :style="{'background':plan.color}" :title="plan.date"></div>
                                </div>

                            </div>
                            <div style="width: 100%;border-bottom: 1px dashed rgba(22,25,49,0.5);position: absolute;top: 10px;z-index: 1;"></div>
                        </div>


                    </div>
                </div>
            </div>
        </vue-scroll>
    </div>


</template>

<script>
    export default {
        data() {
            return {
                studentPeriodStyles: [
                    {
                        name: '未上',
                        color: 'rgba(216,216,216)'
                    },
                    {
                        name: '签到',
                        color: '#D2EAB9'
                    },
                    {
                        name: '缺席',
                        color: '#946767'
                    },
                    {
                        name: '调课',
                        color: '#81AEE4'
                    },
                    {
                        name: '旷课',
                        color: '#E77E7E'
                    },
                    {
                        name: '请假',
                        color: 'rgba(133,214,225,1)'
                    },
                    {
                        name: '退费',
                        color: '#F5A77C'
                    },
                    {
                        name: '待购',
                        color: 'rgba(204,204,0,1)'
                    },
                    {
                        name: '未买',
                        color: '#898989'
                    },
                    {
                        name: '分期',
                        color: 'rgb(213,42,136)'
                    }
                ],
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowPeriods();
        },
        methods: {
            handleShowPeriods() {
                this.$wApi.send(this.$parentInfo.path, 'finishedPeriod', {
                    'student_id': this.$parentInfo.student_id,
                    'type': 'history',
                });
            },
            handleShowPeriod(classPlanStudent_id, status) {
                switch (status) {
                    case 'leaving':
                        if (status == 'orgReason') {
                            this.$parent.studentPeriod.leavingPeriod.options.push({
                                value: 'refundAll',
                                label: '全额退费'
                            })
                        }
                        break;
                    case 'switching':
                        this.$wApi.send(this.$parent.path, 'switchingPeriod', {
                            'classPlanStudent_id': classPlanStudent_id,
                        });
                        break;
                }
            }
        }
    }
</script>

<style scoped>

</style>
